import Chart from "chart.js/auto";
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Set Globals
window.globals = {
  Chart,
  ChartDataLabels,
}